import { resolveComponent as _resolveComponent, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "m-auto px-8 md:px-20 pb-8" }
const _hoisted_2 = { class: "max-w-screen-2xl m-auto" }
const _hoisted_3 = { class: "pt-10 pb-5 flex justify-between" }
const _hoisted_4 = { class: "flex items-center pb-10" }
const _hoisted_5 = { class: "mb-5" }
const _hoisted_6 = { class: "text-3xl font-bold flex justify-between" }
const _hoisted_7 = { class: "flex justify-between" }
const _hoisted_8 = { class: "font-bold" }
const _hoisted_9 = { class: "font-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!
  const _component_BadgeStato = _resolveComponent("BadgeStato")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_SottoProgettoHead = _resolveComponent("SottoProgettoHead")!
  const _component_VersioneSottoProgetto = _resolveComponent("VersioneSottoProgetto")!
  const _component_InfiniteLoading = _resolveComponent("InfiniteLoading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
      _createVNode(_component_Loading, { visible: _ctx.loading }, null, 8, ["visible"])
    ])),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Breadcrumbs, { paths: _ctx.getBreadcrumbsPath }, null, 8, ["paths"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_BadgeStato, {
            stato: _ctx.sottoprogetto?.stato
          }, null, 8, ["stato"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", null, _toDisplayString(_ctx.sottoprogetto?.titolo), 1),
            _createElementVNode("span", null, _toDisplayString(_ctx.sottoprogetto?.cod_nodo), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", null, [
              _createElementVNode("small", null, [
                _cache[0] || (_cache[0] = _createTextVNode("Da ")),
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.sottoprogetto?.data_inizio ? _ctx.$filters.toDate(_ctx.sottoprogetto?.data_inizio) : '-'), 1),
                _cache[1] || (_cache[1] = _createTextVNode(" a ")),
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.sottoprogetto?.data_fine ? _ctx.$filters.toDate(_ctx.sottoprogetto?.data_fine) : '-'), 1)
              ])
            ]),
            _createVNode(_component_Checkbox, {
              checkClass: "h-3 w-3",
              checked: _ctx.solo_manuali,
              onChange: _ctx.onToggleManuali
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode(" Mostra solo versioni manuali ")
              ])),
              _: 1
            }, 8, ["checked", "onChange"])
          ])
        ]),
        _createVNode(_component_SottoProgettoHead, {
          budget: _ctx.sottoprogetto.budget ? `${_ctx.$filters.toEuroCurrency(Number(_ctx.sottoprogetto.budget))}` : '-',
          totaleRicavi: _ctx.ActiveTab && _ctx.TotaleRicaviProgetto(_ctx.ActiveTab.sezioni) ? _ctx.$filters.toEuroCurrency(_ctx.TotaleRicaviProgetto(_ctx.ActiveTab.sezioni)) : '-',
          budgetProgetto: _ctx.ActiveTab && _ctx.TotaleBudgetProgetto(_ctx.ActiveTab.sezioni) ? _ctx.$filters.toEuroCurrency(_ctx.TotaleBudgetProgetto(_ctx.ActiveTab.sezioni)) : '-',
          commissioni: _ctx.ActiveTab && _ctx.TotaleCommissioniProgetto(_ctx.ActiveTab.sezioni) ? _ctx.$filters.toEuroCurrency(_ctx.TotaleCommissioniProgetto(_ctx.ActiveTab.sezioni)) : '-',
          totaleCosti: _ctx.ActiveTab && _ctx.TotaleCostiEuroProgetto(_ctx.ActiveTab.sezioni) ? _ctx.$filters.toEuroCurrency(_ctx.TotaleCostiEuroProgetto(_ctx.ActiveTab.sezioni)) : '-',
          risorseInterne: _ctx.dati_ultima_versione && _ctx.dati_ultima_versione.risorse_interne ? _ctx.dati_ultima_versione.risorse_interne : '-',
          utile: _ctx.ActiveTab && _ctx.TotaleUtiliProgetto(_ctx.ActiveTab.sezioni).toLocaleValueString() ? _ctx.$filters.toEuroCurrency(_ctx.TotaleUtiliProgetto(_ctx.ActiveTab.sezioni)) : '-',
          margine: _ctx.ActiveTab && _ctx.TotaleMolProgetto(_ctx.ActiveTab.sezioni) ? `${_ctx.TotaleMolProgetto(_ctx.ActiveTab.sezioni).toLocaleValueString()} %` : '-',
          fee: _ctx.ActiveTab && _ctx.TotaleFeesSezioni(_ctx.ActiveTab.sezioni).toLocaleValueString(2, 2)
        }, null, 8, ["budget", "totaleRicavi", "budgetProgetto", "commissioni", "totaleCosti", "risorseInterne", "utile", "margine", "fee"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.versioni.rows, (v, i) => {
          return (_openBlock(), _createBlock(_component_VersioneSottoProgetto, {
            key: i,
            class: "pt-4 border-b-2 border-next-gray-md pb-2",
            versione: {...v, data: JSON.parse(v.data)},
            sottoprogetto: _ctx.sottoprogetto
          }, null, 8, ["versione", "sottoprogetto"]))
        }), 128)),
        _createVNode(_component_InfiniteLoading, {
          onInfinite: _ctx.versioni.fetchNextPage,
          identifier: _ctx.versioni.infiniteIdentifier,
          style: {"min-height":"1px"}
        }, {
          complete: _withCtx(() => _cache[3] || (_cache[3] = [
            _createElementVNode("div", { class: "text-center pb-3" }, "Non ci sono altre versioni.", -1)
          ])),
          _: 1
        }, 8, ["onInfinite", "identifier"])
      ])
    ])
  ], 64))
}